import { render } from "./main-blog.vue?vue&type=template&id=7d8e8255"
import script from "./main-blog.vue?vue&type=script&lang=js"
export * from "./main-blog.vue?vue&type=script&lang=js"

import "./main-blog.vue?vue&type=style&index=0&id=7d8e8255&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__